import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PlanoContaMatrizListarRoutingModule } from "./plano-contas-matriz-listar-routing.module";
import { PlanoContaMatrizListarComponent } from "./plano-contas-matriz-listar.component";

import { ButtonModule } from "primeng/button";
import { ChipModule } from "primeng/chip";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { RippleModule } from "primeng/ripple";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { SplitButtonModule } from 'primeng/splitbutton';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { MessagesModule } from 'primeng/messages';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { PanelModule } from "primeng/panel";


@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        InputTextModule,
        InputTextareaModule,
        FileUploadModule,
        RippleModule,        
        ChipModule,
        TableModule,
        EditorModule,
        PlanoContaMatrizListarRoutingModule,
        HttpClientModule,        
        TooltipModule,
        DividerModule,
        SplitButtonModule,
        ConfirmDialogModule,
        MessagesModule,
        PanelModule,
        ProgressSpinnerModule
    ],
    providers: [ConfirmationService],
    declarations: [PlanoContaMatrizListarComponent]
})
export class PlanoContaMatrizListarModule { }
